/**
 * Format date comming from firestore
 * */
export const formatFromDb = (h) => {
      if (typeof h === 'object' && typeof h.toDate === 'function') {
        return h.toDate();
      } else return h;
    };
